import { AnimatePresence, motion } from 'framer-motion';
import useParticipantsWithHost from '../../hooks/useParticipantsWithHost';
import useWSFeedbackMessages from '../../hooks/useWSFeedbackMessages';
import { useManualMessageScript } from '../../utils/manualMessageScript';
import GuaraSpeaker from '../GuaraSpeaker/GuaraSpeaker';
import AbsoluteContainer from './Elements/AbsoluteContainer';
import './FeedbackBalloon.css';

export default function FeedbackBalloon({ currentPhase, debugMode = false }) {
  const { activeMessage, insertManualMessage } = useWSFeedbackMessages(debugMode);
  const { whoAmI } = useParticipantsWithHost();

  // Usa o hook do script que monitora mudanças de phase (sempre ativo)
  useManualMessageScript(insertManualMessage, currentPhase);

  // Lógica de direcionamento de mensagens
  const shouldShowMessage = (message) => {
    if (!message?.content) return false;

    // Se não tem showTo, assume 'both'
    const showTo = message.showTo || 'both';

    // Mod sempre vê todas as mensagens
    if (whoAmI === 'MOD') return true;

    // Verifica se a mensagem é para o participante atual
    if (showTo === 'both') return true;
    if (showTo === whoAmI) return true;

    return false;
  };

  const shouldShow = shouldShowMessage(activeMessage);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 4
      }}
    >
      {/* Guará Speaker */}
      <GuaraSpeaker isVisible={shouldShow} />

      <AbsoluteContainer
        style={{
          right: '32px',
          bottom: '32px',
          zIndex: 5,
          width: '300px',
          height: 'auto',
          display: 'flex',
          justifyContent: 'flex-end'
        }}
    >
      <AnimatePresence>
        {shouldShow && (
          <motion.div
        className="feedback-balloon"
        initial={{ opacity: 0, y: 100, scale: 0.8 }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
          transition: {
            duration: 0.8,
            ease: "easeOut",
            y: {
              type: "spring",
              stiffness: 300,
              damping: 20,
              mass: 0.8
            },
            scale: {
              type: "spring",
              stiffness: 400,
              damping: 15
            }
          }
        }}
        exit={{
          opacity: 0,
          y: [0, -40, 150], // sobe e depois desce
          scale: 0.8,
          transition: {
            duration: 30,       // tempo total
            ease: "easeInOut",
            y: {
              times: [0, 0.7, 1], // 0s no início, 0.6 do tempo no topo, 1 no final
              type: "tween"
            }
          }
        }}
      >
        <div className="feedback-content">
          <div className="feedback-message">
            <div className="feedback-text">{activeMessage?.content || "Excellent use of past tense! Great storytelling! Keep the good work!"}</div>
          </div>
        </div>
            <div className="feedback-tail" />
          </motion.div>
        )}
      </AnimatePresence>
    </AbsoluteContainer>
    </div>
  );
}
